












import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({})
export default class BackgroundLines extends Vue {
  // Ссылки на глобальное состояние
  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;
  @State(state => state.app.showBackgroundLines) showBackgroundLines!: boolean;

  @Prop({default:true}) handleLinesPosition!:boolean;

  /** Количество шторок к отображению */
  get numberOfCurtains(): number {
    if (this.$browser.width > 900) return 5;
    else if (this.$browser.width > 400) return 4;
    else return 3;
  }

  /**
   *  Считает ширину для шторки с указанный номером
   * @returns {number} Ширина в пикселях
   * @param {number} index  Номер шторки
   * */
  calcWidthForSection(index: number): number {
    let widthForFirstAndLast = 220;
    if (this.$browser.width < 1200) widthForFirstAndLast = 80;
    if (this.$browser.width < 1020) widthForFirstAndLast = 35;

    let width =
      (this.$browser.width - widthForFirstAndLast * 2) /
      (this.numberOfCurtains - 2);
    if (index == 1 || index == this.numberOfCurtains) {
      return widthForFirstAndLast;
    }

    return width;
  }

  /**
   * Определяет позицию шторки по ее номеру
   * @returns {number} Отступ слева в пикселях
   * @param {number} index  Номер шторки
   * */
  calcLeftForSection(index: number): number {
    let left = 0;
    for (let q = 1; q < index; q++) {
      left += this.calcWidthForSection(q);
    }
    return left;
  }
}
